import { useQuery } from "@apollo/client";
import { ChevronLeft, Print } from "@mui/icons-material";
import { Alert, Button, Stack } from "@mui/material";
import { Box } from "@mui/system";
import React, { useMemo, useState } from "react";
import { Trans } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import { RECEIPT_BY_RECEIPT } from "../../Api";
import { useAuth } from "../../util/AuthContext.js";
import { getReceiptFromDolToken } from "../../util/authHelpers.js";
import ReceiptContent from "./ReceiptContent.js";

export default () => {
	const auth = useAuth();
	const history = useHistory();
	const location = useLocation();

	const [failureCount, setFailureCount] = useState(0);

	const receiptNo = useMemo(() => {
		const urlParams = new URLSearchParams(location.search);
		return urlParams.get("receiptNo") || getReceiptFromDolToken();
	}, [location.search]);

	const {
		data,
		error,
		loading: isLoading
	} = useQuery(RECEIPT_BY_RECEIPT, {
		variables: { receipt: receiptNo },
		skip: !receiptNo,
		context: {
			maxRetries: 5,
			onRetry: setFailureCount
		}
	});
	const orderDetails = data?.receiptByReceiptNo;

	const printReceipt = () => {
		window.print();
	};

	return (
		<>
			<Stack
				direction={{ xs: "column", sm: "row" }}
				justifyContent="space-between"
				sx={{ "@media print": { display: "none" } }}
			>
				<Button
					size="small"
					color="secondary"
					startIcon={<ChevronLeft />}
					sx={{ mb: { xs: 1, sm: 0 } }}
					id="backtoOrderHistory"
					onClick={() => {
						history.push("/");
					}}
				>
					{auth !== "dol" ? (
						// We might be able to do better: Button will not be displayed if authenticated via DOL and login.
						<Trans i18nKey="Common.backToOrderHistory">Back to Order History</Trans>
					) : (
						<Trans i18nKey="Common.customerSupportHome">Customer Support Home</Trans>
					)}
				</Button>
				<Button
					size="small"
					color="primary"
					startIcon={<Print />}
					id="print"
					onClick={printReceipt}
				>
					<Trans i18nKey="Common.print">Print</Trans>
				</Button>
			</Stack>

			{!receiptNo ? (
				<Box sx={{ maxWidth: "680px", margin: "1rem 0 2rem" }}>
					<Alert severity="error">
						<Trans i18nKey="Common.error.invalidLink">
							It looks like you've used an invalid link: no receipt specified
						</Trans>
					</Alert>
				</Box>
			) : error ? (
				<Box sx={{ maxWidth: "680px", margin: "1rem 0 2rem" }}>
					<Alert severity="error">
						<Trans i18nKey="Common.error.orderNotFound">
							We're having trouble finding your order. Please reload the page. If the
							issue persists, try logging in or contact customer support directly.
						</Trans>
					</Alert>
				</Box>
			) : (
				<>
					<ReceiptContent
						details={orderDetails}
						loading={
							isLoading && {
								failureCount,
								retries: 5
							}
						}
					/>

					{orderDetails?.relatedOrders?.map((order, index) => (
						<ReceiptContent details={order} key={index} />
					))}
				</>
			)}
		</>
	);
};
